import { css } from 'lit';
import { fsDesignToken } from '../../../core/style-util.js';

export const style = css`
  .card.container {
    border-radius: 4px;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);
    box-sizing: border-box;
    height: 100%;
    padding: 16px;

    &.selected {
      border: 1px solid #d4d4d4;
      box-shadow: none;
    }
  }

  .flex {
    display: flex;
    flex-direction: row;
  }

  .loan-info {
    margin-left: ${fsDesignToken('fsSizeSpacingMedium1')};
  }

  .placeholder {
    background-color: ${fsDesignToken('fsColorDigitalGray10')};
    border-radius: ${fsDesignToken('fsRadiusMedium')};
    padding: ${fsDesignToken('fsSizeSpacingSmall1')};

    &.delay {
      background-color: inherit;
      border: ${fsDesignToken('fsBorderDashedMedium')};
      border-color: ${fsDesignToken('fsColorDigitalGray30')};
      font-size: ${fsDesignToken('fsFontBodyTiny')};
    }
  }

  .card-button {
    margin-top: 1em;
    width: 100%;
  }

  .helper-text {
    margin-top: 0.5em;
  }
`;
